import { DateTime } from 'luxon';
import { MarginHistoryDirection } from 'src/lib/margin/types';
import { create } from 'zustand';

type FilterState = {
  showFilters: boolean;
  filterCurrentInstrument?: string;
  filterStartDate?: DateTime;
  filterEndDate?: DateTime;
  filterDirections: MarginHistoryDirection[];
  filterEvents: string[];
  setShowFilters: (showFilters: boolean) => void;
  setFilterCurrentInstrument: (filterCurrentInstrument?: string) => void;
  setFilterStartDate: (filterStartDate?: DateTime) => void;
  setFilterEndDate: (filterEndDate?: DateTime) => void;
  setFilterDirections: (filterDirections: MarginHistoryDirection[]) => void;
  setFilterEvents: (filterEvents: string[]) => void;
  resetFilters: () => void;
};

const useMarginPositionsTableFilterStore = create<FilterState>()((set) => ({
  showFilters: false,
  filterCurrentInstrument: '',
  filterDirections: [],
  filterEvents: [],

  setShowFilters: (showFilters: boolean) => {
    set({ showFilters });
  },
  setFilterCurrentInstrument: (filterCurrentInstrument?: string) => {
    set({ filterCurrentInstrument });
  },
  setFilterStartDate: (filterStartDate?: DateTime) => {
    set({ filterStartDate });
  },
  setFilterEndDate: (filterEndDate?: DateTime) => {
    set({ filterEndDate });
  },
  setFilterDirections: (filterDirections?: MarginHistoryDirection[]) => {
    set({ filterDirections });
  },
  setFilterEvents: (filterEvents: string[]) => {
    set({ filterEvents });
  },
  resetFilters: () => {
    set({
      filterCurrentInstrument: '',
      filterStartDate: undefined,
      filterEndDate: undefined,
      filterEvents: [],
      filterDirections: [],
    });
  },
}));

export { useMarginPositionsTableFilterStore };
